import React from "react"
import PropTypes from "prop-types"
import { withRadium } from "higher-order-components"
import gtmHandler from "AtomicUtils/gtmHandler"
import { ChevronIcon } from "components"
/**
 * Navigation Link Component.
 * @todo  Dev mode complains that `active` and `subNav` are unknown props
* @param {String} label - Navigation Label
* @param {String} href - Navigation Url
* @returns {ReactElement} React Component
*/
const GlobalNavLink = ({
  subNav, gtm, active, onClick, type, href, label, children, chevron
}) => {
  const setButtonStyles = () => {
    const base = []
    const style = subNav ? subNavStyles : styles
    base.push(styles.buttonBase)
    base.push(subNav ? subNavStyles.button : styles.button)
    base.push(active ? style.buttonActive : { borderBottomColor: "transparent" })
    base.push({
      ":focus": style.buttonFocus,
      ":hover": style.buttonFocus
    })
    return base
  }
  const handleInteraction = (event) => {
    if (event.type === "keydown" && event.key !== "Enter") return
    if (gtm && gtm.category) {
      // If not, use CMS gtm event
      gtmHandler({
        pageCategory: gtm.category,
        pageAction: gtm.action
      })
    }
    if (onClick) onClick(event)
  }
  const Tag = type || href ? "a" : "span"
  return (
    <Tag
      data-test="nav-link"
      style={[setButtonStyles()]}
      tabIndex="0"
      href={href}
      onKeyDown={handleInteraction}
      onClick={handleInteraction}>
      {children}
      {label}
      {chevron &&
        <ChevronIcon style={{
          width: "10px",
          height: "10px",
          margin: "5px",
          color: `${active} ? '#ffffff' : '#999999'`,
          transformOrigin: "50% 50%",
          transform: `rotate(${active ? "0deg" : "-180deg"})`,
          transitionDuration: "0.4s"
        }} />
      }
    </Tag>
  )
}

GlobalNavLink.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  active: PropTypes.bool,
  chevron: PropTypes.bool,
  subNav: PropTypes.bool
}

export default withRadium()(GlobalNavLink)

const styles = {
  buttonBase: {
    textDecoration: "none",
    textTransform: "uppercase",
    borderBottomColor: "transparent",
    display: "flex",
    cursor: "pointer",
    transition: ".25s",
    userSelect: "none",
    padding: ".5em 0",
    alignItems: "center",
    letterSpacing: ".2em",
    fontWeight: 600,
    fontSize: "80%"
  },
  button: {
    color: "#999999"
  },
  buttonActive: {
    color: "white",
    borderBottomColor: "#910A2D",
  },
  buttonFocus: {
    outline: 0
  }
}

const subNavStyles = {
  base: {
    display: "block",
    margin: "auto",
    flex: "1 1 100%"
  },
  button: {
    color: "#808080",
    margin: ".5em 2.5em",
    "@media (min-width: 1200px)": {
      fontSize: "1.8vw",
      padding: ".25em 0"
    },
    "@media (min-width: 768px) and (max-width: 1200px)": {
      fontSize: "2.7vw",
      padding: ".25em 0"
    }
  },
  buttonActive: {
    color: "#101010"
  },
  buttonFocus: {
    color: "#101010",
    outline: 0
  }
}



// WEBPACK FOOTER //
// ./src/components/global-nav-link/index.jsx